import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']
  
  connect() {
    const activeTab = window.location.href.split('?tab=')[1]
    if (this.tabList.includes(activeTab)) { 
      this.togglePanels(activeTab) 
      this.toggleTabs(activeTab) 
    }
  }
  
  show(event) {
    event.preventDefault()
    const targetPanel = event.target.dataset.tabPanel
    this.togglePanels(targetPanel)
    this.toggleTabs(targetPanel)
  }
  
  activateTab(event) {
    this.toggleTabs(event.target.dataset.activateTab)
  }
  
  togglePanels(showPanelId) {
    this.panelTargets.forEach((panel) => {
      if (panel.dataset.tabPanelId == showPanelId) {
        panel.classList.remove('hide')
      } else {
        panel.classList.add('hide')
      }
    })
  }
  
  toggleTabs(showTabId) {
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tabPanel == showTabId) {
        tab.classList.add('current')
      } else {
        tab.classList.remove('current')
      }
    })
  }
  
  get tabList() {
    return this.data.get('list').split(', ')
  }
}